import React, {
  useCallback,
  useState,
  useContext,
  createContext,
  useMemo,
} from 'react';

const ModalColaboradorContext = createContext({});

export function ModalColaboradorProvider({ children }) {
  const [show, setShow] = useState(false);

  const showModal = useCallback(() => {
    setShow(true);
  }, []);

  const closeModal = useCallback(() => {
    setShow(false);
  }, []);

  const contextValue = useMemo(
    () => ({
      show,
      showModal,
      setShow,
      closeModal,
    }),
    [show, showModal, closeModal],
  );

  return (
    <ModalColaboradorContext.Provider value={contextValue}>
      {children}
    </ModalColaboradorContext.Provider>
  );
}

export function useModalColaborador() {
  const context = useContext(ModalColaboradorContext);

  if (!context)
    throw new Error(
      'useModalColaborador must be used within a ModalColaboradorProvider',
    );

  return context;
}
